import { createContext, useContext } from "react";
import { Api } from "shared/api";

export const ApiContext = createContext<Api | null>(null);

export function useApi() {
  return useContext(ApiContext);
}
